import fetch from "auth/FetchInterceptor";

const companyService = {};

companyService.get = function (params = {}) {
	return fetch({
		url: "/v1/rest/company",
		method: "get",
		params,
	});
};

companyService.post = function (data) {
	return fetch({
		url: "/v1/rest/company",
		method: "post",
		data: data,
	});
};

companyService.put = function (id, data) {
	return fetch({
		url: `/v1/rest/company/${id}`,
		method: "put",
		data: data,
	});
};

companyService.getById = function (id) {
	return fetch({
		url: `/v1/rest/company/${id}`,
		method: "get",
	});
};

export default companyService;
